module.exports = __webpack_public_path__ + "static/media/baker-steel-gold-i.3d9c2c74.csv";